exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dark[data-v-60985fc1] {\r\n  background-color: transparent !important;\r\n  color: #fff !important;\n}\r\n", ""]);

// exports
